/**
 * Created by vladislav on 12.07.2021
 */

const TreasureSearchMissionLogic = function (mission) {
    cleverapps.EventEmitter.call(this);

    this.mission = mission;
    this.minigame = mission.minigame;

    this.checkComplete();

    this.onUpdateCurrency = function () {};

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.mission.result}`, once: true });
    }
};

TreasureSearchMissionLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
TreasureSearchMissionLogic.prototype.constructor = TreasureSearchMissionLogic;

TreasureSearchMissionLogic.prototype.checkComplete = function () {
    if (this.isFinished()) {
        this.mission.complete();

        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
    }
};

TreasureSearchMissionLogic.prototype.isFinished = function () {
    return this.mission.result > TreasureSearch.FIELD_SIZE_BY_STAGES.length - 1;
};

TreasureSearchMissionLogic.prototype.processEvent = function (options) {
    this.mission.updateCurrency(options.amount, options.details);

    if (options.amount > 0) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.TREASURE_SEARCH_RECEIVE_SHOVELS, {
            value: options.amount
        });
        this.trigger("updateResult");
    } else {
        cleverapps.eventBus.trigger("use_shovels");
    }

    this.onUpdateCurrency();
    this.updateIcon();
};

TreasureSearchMissionLogic.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    const TreasureSearchLevelRewards = {
        "hard": 4.5,
        "tricky": 2,
        "bonus": 2,
        "default": 1.5
    };
    game.addMissionReward(this.mission.type, game.getNormalizedLevelReward(TreasureSearchLevelRewards, "match3"));
};

TreasureSearchMissionLogic.prototype.getResult = function () {
    return this.mission.result;
};

TreasureSearchMissionLogic.prototype.getCollectAmount = function () {
    return this.mission.currency;
};

TreasureSearchMissionLogic.prototype.getOrderRewards = function (order) {
    const stagesInIngredients = order.ingredients
        .reduce((acc, ingredient) => acc + ingredient.amount * (ingredient.unit.stage + 1), 0);

    return {
        missionType: this.mission.type,
        amount: Math.max(0, Math.ceil(stagesInIngredients / 3) - 1)
    };
};

TreasureSearchMissionLogic.prototype.onUpdateMission = function (delta) {
    if (delta) {
        this.trigger("updateStatus");
    }
};

TreasureSearchMissionLogic.prototype.updateIcon = function () {
    this.mission.updateMissionIcon();
    this.trigger("updateStatus");
};

TreasureSearchMissionLogic.prototype.calcStatusInfo = function () {
    return {
        text: `%% ${this.getCollectAmount()}`,
        icons: {
            "%%": this.mission.getIcon()
        }
    };
};
